var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 3.33332C13.6751 3.33332 16.6667 6.32498 16.6667 9.99998C16.6667 13.675 13.6751 16.6666 10.0001 16.6666C6.32508 16.6666 3.33341 13.675 3.33341 9.99998C3.33341 6.32498 6.32508 3.33332 10.0001 3.33332ZM10.0001 1.66666C5.40008 1.66666 1.66675 5.39998 1.66675 9.99998C1.66675 14.6 5.40008 18.3333 10.0001 18.3333C14.6001 18.3333 18.3334 14.6 18.3334 9.99998C18.3334 5.39998 14.6001 1.66666 10.0001 1.66666Z",
    fill: "#0071D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 8.74999H9.16675V14.5833H10.8334V8.74999Z",
    fill: "#0071D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 5.41666H9.16675V7.08332H10.8334V5.41666Z",
    fill: "#0071D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.759c1d2d7de909eac59b2a4b077151bb.svg";
export { ForwardRef as ReactComponent };